export const CONTACT = {
  address: "Örnek Sokak Örnek Cadde 56/2 Balgat - Ankara",
  phone: "0850 850 00 00",
  phoneHref: "tel:08508500000",
  email: "info@balgatmining.com",
};

const tr = {
  nav: { about: "Hakkımızda", kaolin: "Kaolen", process: "Süreç", contact: "İletişim", cta: "Teklif Alın" },
  hero: {
    eyebrow: "Ankara · Kaolen & Endüstriyel Mineraller",
    lines: ["Toprağın", "en saf", "beyazını"],
    accent: "işliyoruz.",
    sub: "Balgat Mining; seramik, kâğıt, boya ve refrakter sanayisine istikrarlı kalitede kaolen tedarik eden, sorumlu madenciliği ilke edinmiş bir kurumdur.",
    cta1: "Kaolen Ürünleri", cta2: "Bize Ulaşın", scroll: "Kaydırın",
    badge: "Al₂O₃ zengin · yüksek beyazlık",
  },
  stats: {
    title: "Rakamlarla Balgat Mining",
    items: [
      { value: 1, suffix: "M+", label: "Ton kaolen tedariki" },
      { value: 250, suffix: "+", label: "Kurumsal müşteri" },
      { value: 15, suffix: "+", label: "Yıllık saha tecrübesi" },
      { value: 12, suffix: "", label: "İhracat yapılan ülke" },
    ],
  },
  about: {
    label: "01 — Hakkımızda",
    title: ["Doğal kaynakları", "sorumlulukla", "ekonomiye kazandırıyoruz."],
    p1: "Balgat Mining olarak doğal kaynakları verimli ve sorumlu biçimde ekonomiye kazandırmayı amaçlıyoruz. Saha planlamasından üretime kadar her aşamada iş güvenliğini gözetmeyi ve faaliyetlerimizin çevre üzerindeki etkilerini azaltmayı önceliğimiz olarak görüyoruz.",
    p2: "İş ortaklarımızla beklentileri en başta netleştirmeye ve proje boyunca açık iletişim kurmaya önem veriyoruz. Hedefimiz, faaliyet gösterdiğimiz bölgelerde yerel ekonomiye katkı sağlayan ve uzun vadeli iş birlikleri kuran güvenilir bir madencilik şirketi olmak.",
    pillars: [
      { t: "İş Güvenliği", d: "Sahadan tesise her adımda önce insan." },
      { t: "Çevresel Sorumluluk", d: "Etkiyi azaltan planlama ve saha rehabilitasyonu." },
      { t: "Şeffaf İletişim", d: "Beklentiler en başta, açık iletişim proje boyunca." },
    ],
  },
  kaolin: {
    label: "02 — Kaolen",
    title: ["Beyaz altın:", "kaolen."],
    intro: "Ana ürünümüz kaolen; ince tane yapısı, yüksek beyazlığı ve kararlı kimyasal bileşimiyle pek çok sanayi kolunun temel hammaddesidir. Her parti, müşterinin proses ihtiyacına göre seçilir ve laboratuvar kontrolünden geçer.",
    specsTitle: "Tipik Analiz Değerleri",
    specsNote: "Değerler örnek amaçlıdır; parti bazlı analiz raporu talep üzerine paylaşılır.",
    specs: [["Al₂O₃", "%33 – 37"], ["SiO₂", "%46 – 50"], ["Fe₂O₃", "< %0,8"], ["TiO₂", "< %0,5"], ["Beyazlık (ISO)", "%82 – 88"], ["Nem", "< %10"]],
    grades: [
      { code: "BLG-K1", name: "Seramik Kaolen", d: "Sağlık gereçleri, karo ve sofra eşyası için yüksek plastisiteli kalite." },
      { code: "BLG-K2", name: "Dolgu Kaolen", d: "Kâğıt, boya ve plastikte opaklık ve yüzey kalitesi sağlar." },
      { code: "BLG-K3", name: "Refrakter Kaolen", d: "Yüksek alümina içeriğiyle ısıya dayanıklı uygulamalar." },
    ],
    uses: ["Seramik & Porselen", "Kâğıt", "Boya & Kaplama", "Refrakter", "Kauçuk & Plastik", "Yapı Kimyasalları", "Cam Elyafı", "Kozmetik"],
    usesTitle: "Kullanım Alanları",
  },
  process: {
    label: "03 — Süreç",
    title: ["Sahadan sevkiyata,", "kontrollü bir zincir."],
    steps: [
      { t: "Saha Planlama", d: "Jeolojik etüt, rezerv modelleme ve çevresel etki değerlendirmesi." },
      { t: "Üretim", d: "İş güvenliği protokolleriyle planlı ve seçici kazı." },
      { t: "Zenginleştirme", d: "Yıkama, eleme ve sınıflandırma ile istikrarlı kalite." },
      { t: "Kalite Kontrol", d: "Her parti için kimyasal ve fiziksel laboratuvar analizi." },
      { t: "Lojistik", d: "Dökme, big-bag veya torbalı; zamanında sevkiyat." },
    ],
  },
  marquee: ["Kaolen", "Sorumlu Madencilik", "İş Güvenliği", "Uzun Vadeli Ortaklık", "Ankara"],
  contact: {
    label: "04 — İletişim",
    title: ["Projenizi", "konuşalım."],
    sub: "Numune, teknik föy veya fiyat teklifi için bize doğrudan ulaşın.",
    address: "Adres", phone: "Telefon", email: "E-posta", map: "Haritada Gör",
  },
  footer: { rights: "Tüm hakları saklıdır.", top: "Başa Dön" },
};

const en = {
  nav: { about: "About", kaolin: "Kaolin", process: "Process", contact: "Contact", cta: "Get a Quote" },
  hero: {
    eyebrow: "Ankara · Kaolin & Industrial Minerals",
    lines: ["We refine", "the purest", "white of"],
    accent: "the earth.",
    sub: "Balgat Mining supplies kaolin of consistent quality to the ceramics, paper, paint and refractory industries, guided by responsible mining.",
    cta1: "Kaolin Products", cta2: "Contact Us", scroll: "Scroll",
    badge: "Al₂O₃ rich · high brightness",
  },
  stats: {
    title: "Balgat Mining in numbers",
    items: [
      { value: 1, suffix: "M+", label: "Tonnes of kaolin supplied" },
      { value: 250, suffix: "+", label: "Corporate clients" },
      { value: 15, suffix: "+", label: "Years of field experience" },
      { value: 12, suffix: "", label: "Export countries" },
    ],
  },
  about: {
    label: "01 — About Us",
    title: ["Bringing natural", "resources to the economy,", "responsibly."],
    p1: "At Balgat Mining, we aim to bring natural resources into the economy efficiently and responsibly. From site planning to production, we prioritise occupational safety at every stage and work to reduce the environmental impact of our operations.",
    p2: "We value clarifying expectations with our partners from the very start and maintaining open communication throughout each project. Our goal is to be a trusted mining company that contributes to local economies in the regions where we operate and builds long-term partnerships.",
    pillars: [
      { t: "Occupational Safety", d: "People first, at every step from site to plant." },
      { t: "Environmental Care", d: "Impact-reducing planning and site rehabilitation." },
      { t: "Transparent Dialogue", d: "Clear expectations upfront, open communication throughout." },
    ],
  },
  kaolin: {
    label: "02 — Kaolin",
    title: ["White gold:", "kaolin."],
    intro: "Our core product, kaolin, is a fundamental raw material for many industries thanks to its fine particle structure, high brightness and stable chemistry. Every batch is selected for the client's process and passes laboratory control.",
    specsTitle: "Typical Analysis",
    specsNote: "Values are indicative; batch-specific analysis reports are available on request.",
    specs: [["Al₂O₃", "33 – 37%"], ["SiO₂", "46 – 50%"], ["Fe₂O₃", "< 0.8%"], ["TiO₂", "< 0.5%"], ["Brightness (ISO)", "82 – 88%"], ["Moisture", "< 10%"]],
    grades: [
      { code: "BLG-K1", name: "Ceramic Kaolin", d: "High-plasticity grade for sanitaryware, tiles and tableware." },
      { code: "BLG-K2", name: "Filler Kaolin", d: "Delivers opacity and surface quality in paper, paint and plastics." },
      { code: "BLG-K3", name: "Refractory Kaolin", d: "High alumina content for heat-resistant applications." },
    ],
    uses: ["Ceramics & Porcelain", "Paper", "Paint & Coatings", "Refractories", "Rubber & Plastics", "Construction Chemicals", "Fibreglass", "Cosmetics"],
    usesTitle: "Applications",
  },
  process: {
    label: "03 — Process",
    title: ["From site to shipment,", "a controlled chain."],
    steps: [
      { t: "Site Planning", d: "Geological survey, reserve modelling and environmental assessment." },
      { t: "Extraction", d: "Planned, selective mining under strict safety protocols." },
      { t: "Beneficiation", d: "Washing, screening and classification for consistent quality." },
      { t: "Quality Control", d: "Chemical and physical lab analysis for every batch." },
      { t: "Logistics", d: "Bulk, big-bag or bagged; delivered on time." },
    ],
  },
  marquee: ["Kaolin", "Responsible Mining", "Occupational Safety", "Long-term Partnership", "Ankara"],
  contact: {
    label: "04 — Contact",
    title: ["Let's talk", "about your project."],
    sub: "Reach us directly for samples, technical data sheets or a price quote.",
    address: "Address", phone: "Phone", email: "Email", map: "View on Map",
  },
  footer: { rights: "All rights reserved.", top: "Back to Top" },
};

export const T = { tr, en };
